import classNames from 'classnames';
import { type FC, useEffect, useRef } from 'react';

type Props = {
  isMobileDevice: boolean;
};

export const ProductSearchBoxSkeleteon: FC<Props> = ({ isMobileDevice }) => {
  const dialog = useRef<HTMLDialogElement>(null);

  useEffect(() => {
    dialog.current?.showModal();
  }, []);

  return (
    <dialog
      ref={dialog}
      role="presentation"
      className={classNames(
        'ui-h-full ui-max-h-none ui-w-full ui-max-w-none max-sm:ui-border-0 ui-bg-transparent backdrop:ui-bg-black/40 focus:ui-outline-0',
        isMobileDevice ? 'ui-p-0' : 'ui-p-4'
      )}
    >
      <form
        className={classNames(
          'ui-relative ui-container !ui-block ui-h-max !ui-p-5 !ui-bg-white md:!ui-max-w-screen-md',
          isMobileDevice
            ? '!ui-m-0 !ui-rounded-none !ui-p-0 !ui-max-w-full !ui-min-h-full'
            : 'ui-mt-20 sm:!ui-rounded-2xl !ui-shadow-2xl'
        )}
      >
        <div className="ui-flex ui-items-center ui-justify-between ui-mb-3 ui-px-1.5">
          <div className="ui-w-[172px] ui-h-[24px] ui-rounded ui-bg-gray-300 ui-animate-pulse" />
          <div className="ui-flex ui-flex-row ui-items-center ui-justify-between ui-gap-2">
            <div className="ui-w-[46px] ui-h-[24px] ui-rounded ui-bg-gray-300 ui-animate-pulse" />
            <div className="ui-w-[37.5px] ui-h-[24px] ui-rounded ui-bg-gray-300 ui-animate-pulse" />
          </div>
        </div>
        <div className="!ui-flex ui-items-center">
          <div className="ui-flex-1 ui-relative">
            <div className="ui-h-[48px] ui-rounded ui-bg-gray-300 ui-animate-pulse" />
          </div>
        </div>
      </form>
    </dialog>
  );
};
